// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.LinearGaugeOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import SolidGaugeOptionsBuilder from './Izenda.SolidGaugeOptionsBuilder';
import HighchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import constants from 'logic/data/Izenda.ReportPartChartConstants';
import { isNil, get } from 'lodash/fp';
import { exportClass } from 'share/Izenda.ServiceProvider';

const X_AXIS_CONTAINER_NAME = 'labels';
const Y_AXIS_CONTAINER_NAME = 'values';
const VALUE_WIDTH = 50;

@exportClass('LinearGaugeOptionsBuilder')
export default class LineardGaugeOptionsBuilder extends SolidGaugeOptionsBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */
  buildOptionsByType(visualType: string, userOptions, dataParser): Object {
    const genericOptions = super.buildOptionsByType(visualType, userOptions, dataParser) || {};

    const izendaSeriesConfig = userOptions.izendaSeriesConfig || {};
    const izendaOptions = userOptions.izendaOptions;
    const serieName = izendaOptions.serieName;
    const isInverted = !get('chart.inverted', userOptions);
    const formatter = get('plotOptions.series.dataLabels.formatter', genericOptions);

    return $izenda.extend(true, genericOptions, {
      chart: {
        inverted: isInverted
      },

      plotOptions: {
        series: {
          dataLabels: {
            formatter() {
              const point = this.point;
              const pointOpts = HighchartUtils.getPointOptions(point);

              const val = formatter ? formatter.apply(this, arguments) : HighchartUtils.getPointValue(point);
              const textColor = get('textColor', pointOpts);
              const width = isInverted ? 'auto' : `${VALUE_WIDTH}px`;

              return `<span style="width:${width}; color:${textColor}" class="overflow-text" title="${val}"><span>${val}</span></span>`;
            },
            style: {
              fontSize: '14px'
            }
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGauge/Izenda.LinearGaugeOptionsBuilder.js